import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {SnapshotTypeSearch} from "../PA.UIM.TPM/SnapshotTypeSearch";

var SnapshotSearch: ISearch = {
    searchName: "Find Snapshot",
    renderOptions: {ui5ResourceId: "SnapshotSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
}

var vUI_Snapshot_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_SNAPSHOT_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Snapshot Id',
            columnResourceName: 'colWBSnapshotId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SNAPSHOT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Snapshot Id',
            columnResourceName: 'colSnapshotId',
            alignment: HorizAlignment.Right
        },
        domainOptions: {}
    },
    SNAPSHOT_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Snapshot Type',
            columnResourceName: 'colSnapshotType',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    PARAM_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Parameter Type',
            columnResourceName: 'colParamType',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    SNAPSHOT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Snapshot Name',
            columnResourceName: 'colSnapshotName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },
    PARENT_SNAPSHOT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Parent Snapshot Name',
            columnResourceName: 'colParentSnapshotName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Company Id',
            columnResourceName: 'colWBCompanyId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WB_COMPANY_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Company Id',
            columnResourceName: 'colWBCompanyId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB SalesOrg Id',
            columnResourceName: 'colWBSalesOrgId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WB_SALESAREA_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Snapshot Id',
            columnResourceName: 'colWBSaleAreaId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set',
            columnResourceName: 'colMDSETNAME',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    COMPANY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Company',
            columnResourceName: 'colCOMPANYNAME',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Org',
            columnResourceName: 'colSALESORGNAME',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    SALESAREA_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Area',
            columnResourceName: 'colSALESAREANAME',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var SnapshotSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_SNAPSHOT_ID',
        id_ui: 'SNAPSHOT_ID',
        name: 'SNAPSHOT_NAME'
    },


    searchProviderFields: vUI_Snapshot_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchOptions.where['WB_COMPANY_ID'] = {inq: _.map(usrContext.WB_Companies, 'WB_COMPANY_ID')}
            }

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Snapshot_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    },

    // Filter with drop down in the Snapshot Search
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let searchRequestSubset: { where?: { [id: string]: any } } = {}
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                switch (fieldName) {
                    case "SALESAREA_NAME":
                        searchRequestSubset = {where: {WB_SALESAREA_ID: {inq: _.map(usrContext.WB_SalesAreas, 'WB_SALESAREA_ID')}}}
                        break;
                    case "SALESORG_NAME":
                        searchRequestSubset = {where: {WB_SALESORG_ID: {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}}}
                        break;
                    case "COMPANY_NAME":
                        searchRequestSubset = {where: {WB_COMPANY_ID: {inq: _.map(usrContext.WB_Companies, 'WB_COMPANY_ID')}}}
                        break;
                    case "MDSET_NAME":
                        searchRequestSubset = {where: {WB_MDSET_ID: {inq: _.map(usrContext.WB_MasterDataSets, 'WB_MDSET_ID')}}}
                        break;
                    case "SNAPSHOT_TYPE_NAME":
                        break;

                }
            }

            let results: any[] = undefined
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Snapshot_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    results = res
                    if (fieldName == "SNAPSHOT_TYPE_NAME") {
                        return SearchUtils.getSearchResults(SnapshotTypeSearch, {}, {
                            ProfileId: "default"
                        })
                    }
                })
                .then((types: any) => {

                    if (fieldName == "SNAPSHOT_TYPE_NAME") {
                        results = _.filter(results, row => _.includes(_.map(types, 'SNAPSHOT_TYPE_NAME'), row['SNAPSHOT_TYPE_NAME']))
                    }
                    resolve(_.map(results, (aRow) => {

                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
}


var SnapshotSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "SnapshotSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'SNAPSHOT_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SNAPSHOT_NAME', renderOptions: {}},
        {
            profileFilterName: 'Snapshot Type',
            searchProviderFieldId: 'SNAPSHOT_TYPE_NAME',
            renderOptions: {},
            bMultiSelect: true
        },
        {
            profileFilterName: 'Master Data Set',
            searchProviderFieldId: 'MDSET_NAME',
            bMultiSelect: true,
            renderOptions: {}
        },
        {profileFilterName: 'Company', searchProviderFieldId: 'COMPANY_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Sales Org', searchProviderFieldId: 'SALESORG_NAME', bMultiSelect: true, renderOptions: {}},
        {
            profileFilterName: 'Sales Area',
            searchProviderFieldId: 'SALESAREA_NAME',
            bMultiSelect: true,
            renderOptions: {}
        }
    ],  // ISearchFields
    profileDisplayFields: [
        'SNAPSHOT_ID', 'SNAPSHOT_NAME', 'SNAPSHOT_TYPE_NAME', 'PARENT_SNAPSHOT_NAME',  'MDSET_NAME', 'COMPANY_NAME', 'SALESORG_NAME', 'SALESAREA_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SnapshotSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

SnapshotSearch.searchProfiles = [SnapshotSearchProfileByName]
PAEnvironment.registerBusinessObjectSearch("SnapshotBO", "Snapshot", SnapshotSearch, "Snapshot Search")

export {SnapshotSearch}
